import { Icon } from '../../components/Icon';
import { useStore, type AgendaMode } from '../../state/store';
import { longDate } from '../../lib/time';
import { CalendarView } from './CalendarView';
import { LiveView } from './LiveView';
import { MonthView } from './MonthView';
import { HealthView } from './HealthView';
import { DemoGate } from '../../components/DemoGate';

const MODES: { id: AgendaMode; label: string; icon: string }[] = [
  { id: 'calendario', label: 'Calendario', icon: 'cal' },
  { id: 'envivo', label: 'En vivo', icon: 'live' },
  { id: 'estado', label: 'Estado del mes', icon: 'chart' },
  { id: 'salud', label: 'Salud de equipos', icon: 'orbit' },
];

export function AgendaPage() {
  const s = useStore();
  const real = s.dataSource === 'real';
  return (
    <div className="content">
      <header className="row wrap" style={{ justifyContent: 'space-between', gap: 14 }}>
        <div>
          <div className="eyebrow">Agenda inteligente</div>
          <h1 className="h1">{longDate(s.dataSource === 'real' && s.real.day ? s.real.day.snapshot.today : s.snapshot.today)}</h1>
        </div>
        <div className="row wrap">
          <div className="tabs" role="tablist" aria-label="Vista">
            {MODES.map(m => (
              <button key={m.id} type="button" role="tab" aria-selected={s.agendaMode === m.id}
                className={`tab${s.agendaMode === m.id ? ' on' : ''}`} onClick={() => s.setAgendaMode(m.id)}>
                <Icon name={m.icon} size={17} />{m.label}
              </button>
            ))}
          </div>
          {!real && <button type="button" className="btn" onClick={() => s.go('colores')}><Icon name="palette" size={17} />Colores</button>}
        </div>
      </header>
      {s.agendaMode === 'calendario' && <CalendarView key={s.dataSource} />}
      {s.agendaMode === 'envivo' && (real ? <DemoGate title="En vivo" /> : <LiveView />)}
      {s.agendaMode === 'estado' && (real ? <DemoGate title="Estado del mes" /> : <MonthView />)}
      {s.agendaMode === 'salud' && (real ? <DemoGate title="Salud de equipos" /> : <HealthView />)}
    </div>
  );
}
